
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import AllInclusiveIcon from '@material-ui/icons/AllInclusive';
import { useState, useEffect } from "react";
import axios from 'axios';
import NumberFormat from 'react-number-format';

export default function Sidebar(props) {
  const { sortedTopMmr } = props;
  const [overallSlp, setOverallSlp ] = useState();
  const [slpValue, setSlpValue ] = useState();
  const [axsValue, setAxsValue ] = useState();
  var rowCounter = 1;

  useEffect(() => {
    axios.get(`https://api.coingecko.com/api/v3/simple/token_price/ethereum?contract_addresses=0xcc8fa225d80b9c7d42f96e9570156c65d6caaa25&vs_currencies=php`).then(resp => {
      setSlpValue(resp.data['0xcc8fa225d80b9c7d42f96e9570156c65d6caaa25'].php);
    });

    axios.get(`https://api.coingecko.com/api/v3/coins/axie-infinity`).then(resp => {
      setAxsValue(resp.data.market_data.current_price.php);
    });

  },[]);

  useEffect(() => {
    if(sortedTopMmr.length > 0 ){
      
      var filteredIsko = sortedTopMmr.map(function(datum){
        if(datum.iskoNumber != 0){
          return datum.totalSlp
        } else { 
          return 0
        }
      });
      var reduced = filteredIsko.reduce(function (accumulator, isko) {
        return accumulator + isko;
      }, 0);

      setOverallSlp(
        reduced
      );
      // setOverallSlp(
      //   sortedTopMmr.map(datum => datum.totalSlp).reduce(function (a, b){
      //     console.log("a",a);
      //     console.log("b",b);
      //     return a + b;
      //   },{}) 
      // );
      // setOverallSlp(sortedTopMmr.map(datum => datum.totalSlp).reduce((a, b) => a + b));
    }
    
  }, [sortedTopMmr])

  return (
    <div className="sidebar">
      <div className="sidebar__header">
        <span className="icon"><AllInclusiveIcon /></span>
        <span className="">Statistics</span>
      </div>
      <div className="sidebar__content">
        <div className="info__wrapper">
          <span className="info__text">1 AXS = ₱ </span>        
          <span className="info__text bold">{ axsValue }</span>        
        </div>
        <div className="info__wrapper">
          <span className="info__text">1 SLP = ₱ </span>        
          <span className="info__text bold">{ slpValue }</span>        
        </div>
        <div className="info__wrapper">
          <span className="info__text">Overall SLP: </span>        
          <span className="info__text bold">{ overallSlp }</span>        
        </div>      
        {/* <div className="info__wrapper">
          <span className="info__text">Manager Income </span>        
          <span className="info__text bold">
            <NumberFormat value={ (overallSlp*0.5)*(slpValue) } thousandSeparator={true} prefix={'₱'} decimal={2} fixedDecimalScale={true} onValueChange={(values) => {
            }}/>          
          </span>        
        </div>       */}
        <div className="info__wrapper">
          <span className="info__text">Scholar Income</span>        
          <span className="info__text bold">
            <NumberFormat value={ (overallSlp*0.5)*(slpValue-1.5) } thousandSeparator={true} prefix={'₱'} decimal={2} onValueChange={(values) => {
            }}/>          
          </span>        
        </div>      
      </div>
      
      <div className="sidebar__header">
        <span className="icon"><TrendingUpIcon /></span>
        <span className="">Top MMR</span>
      </div>
      <div className="sidebar__content">
        { sortedTopMmr.length > 0 ? (
            sortedTopMmr.filter((item, index) => index < 20).map((item, index) => (
              <div class="top__rank__wrapper">
                <span className="top__rank__mmr">{rowCounter++} - [ {`${item.mmr}`} ] </span>
                <span className="top__rank__name">{item.iskoNumber}|{`${item.nickname}`}</span>
              </div>
            ))          
          ) : (
            <td colSpan="2">-</td>
        )}  
      </div>
    </div>
  );
}
